// File: src/components/ui/SidebarItem.jsx
// -----------------------------------------------------------------------------
// Un item d’historique ou de projet dans la barre latérale. Il s’affiche comme
// dans le screenshot : icône + texte, état "actif" quand la route est `/chat/:id`.
// -----------------------------------------------------------------------------
import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * @param {Object}   props
 * @param {string}   props.id      Identifiant du chat / projet (slug ou uuid)
 * @param {string}   props.title   Titre affiché (« Rails App Docker Heroku »)
 */
function SidebarItem({ id, title, gender, onClick }) {
  const prefix = gender === 'boy' ? 'm' : 'f'
  return (
    <NavLink to={`/pro/${id}/${gender}`} onClick={onClick} className={({ isActive }) =>
      [
        'flex items-center gap-3 px-4 mb-3 py-1 rounded-xl transition',
        isActive ? 'bg-gray-900 text-white' : 'text-zinc-300 hover:bg-gray-900',
      ].join(' ')
    }>
      <img src={`https://jobs-pictures.s3.eu-north-1.amazonaws.com/photos_${prefix}/${id}_1.jpg`} alt="Lux" className="w-8 h-8 rounded-full object-cover"/>
      <div className="flex items-center gap-2 truncate leading-5"><div className='truncate'>{title}</div></div>
    </NavLink>
  );
}

export default SidebarItem;